import { IonDate } from '../components/IonDate';

//classes
import MemberUser from '../classes/memberUser';
import Event from './event';

const CheckNotNull = Symbol('CheckNotNull');
const SetEvent = Symbol('Event');
const SetInvitationUser = Symbol('SetInvitationUser');

class MeetingInvitation {
    eventID: string = '';
    invitation_userID: string = '';
    invitation_status: number = 0;
    remarks: string = '';
    datetime_created: Date|null = null;
    datetime_updated: Date|null = null;

    public constructor(
        eventID: string,
        invitation_userID: string,
        invitation_status: string,
        remarks: string,
        datetime_created: string,
        datetime_updated: string
    ) {
        this.eventID = this[CheckNotNull](eventID) ? eventID : '';
        this.invitation_userID = this[CheckNotNull](invitation_userID) ? invitation_userID : '';
        this.invitation_status = this[CheckNotNull](invitation_status) ? parseInt(invitation_status) : 0;
        this.remarks = this[CheckNotNull](remarks) ? remarks : '';
        this.datetime_created = this[CheckNotNull](datetime_created) ? IonDate(datetime_created) : null;
        this.datetime_updated = this[CheckNotNull](datetime_updated) ? IonDate(datetime_updated) : null;
    }

    //privates
    private [CheckNotNull] = (value: string) => {
        if(value && value != null && value != 'null' && value.length > 0)
            return true;
        else
            return false;
    }
}
export default MeetingInvitation;